/**
 * Copyright © 2026 Delicious AI, LLC
 */

import { gql } from '@apollo/client'

import { COOLER_STATS_FRAGMENT } from '../fragments/CoolerStatsFragment'

export const GET_STORE_COOLER_STATS = gql`
  query GetStoreCoolerStats(
    $storeId: ID!
    $startDate: DateTime!
    $endDate: DateTime!
    $pagination: OffsetLimitPaginationFilter
    $ordering: CoolerStatsOrdering
  ) {
    storeCoolerStats(
      storeId: $storeId
      startDate: $startDate
      endDate: $endDate
      pagination: $pagination
      ordering: $ordering
    ) {
      totalCount
      results {
        ...CoolerStats
      }
    }
  }
  ${COOLER_STATS_FRAGMENT}
`
